
const environment = {
  production: false,
  host: process.env.REACT_APP_SERVER_HOST || 'https://api.misafecard.com',
};

export default environment;
